import { createClient } from "@supabase/supabase-js";

const localAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjE5ODM4MTI5OTZ9.CRXP1A7WOeoJeXxjNni43kdQwgnWNReilDMblYTn_I0";

const supabaseUrl = import.meta.env.VITE_SUPABASE_V2_URL || "http://127.0.0.1:55321";
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_V2_ANON_KEY || localAnonKey;

// Banner di visibilita': in dev rende esplicito a quale backend e' agganciata
// l'app, per non confondere Docker locale e cloud durante i test.
if (import.meta.env.DEV) {
  const isLocal = /127\.0\.0\.1|localhost/.test(supabaseUrl);
  console.info(
    `%c[supabaseV2] ${isLocal ? "LOCALE (Docker)" : "CLOUD"} → ${supabaseUrl}`,
    `font-weight:bold;color:${isLocal ? "#16a34a" : "#dc2626"}`
  );
}

export const supabaseV2 = createClient(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }
);
